import { gql } from '@apollo/client';

export const GET_DIVISION_QUERY = gql`
  query getDivisionsQuery($group_id: String, $company_id: String) {
    divisions(group_id: $group_id, company_id: $company_id) {
      id
      deleted
      name
      archived
      reference {
        id
        path
        parentPath
      }
    }
  }
`;

export const ALLOW_DELETE_DIVISION_QUERY = gql`
  query allowDeleteDivisionQuery($group_id: String, $company_id: String, $division_id: String) {
    allowDeleteDivision(group_id: $group_id, company_id: $company_id, division_id: $division_id)
  }
`;
